import axios from 'axios';

function chooseServer(typeLetter, typeServer) {
    if (typeLetter === 'polza') {
        return 'https://mailparse.net/polza/annotate';
    } else if (typeLetter === 'sizes') {
        return 'https://mailparse.net/sizes/annotate';
    }

    switch (typeServer) {
    case 'localhost': {
        if (typeLetter === 'cargo') {
            return 'http://localhost:5000/annotate';
        } 
        return 'http://localhost:5001/annotate';
    }
    case 's4.anotatr.com': {
        if (typeLetter === 'cargo') {
            return 'https://mailparse.net/s4/cargo/annotate';
        } 
        return 'https://mailparse.net/s4/vessel/annotate';
    }
    case 'nata.im':
        return `https://mailparse.net/servnata/api${typeLetter}/annotate`;
    case 's11.anotatr.com':
        if (typeLetter === 'cargo') {
            return 'https://mailparse.net/s11/cargo/annotate';
        } 
        return 'https://mailparse.net/s11/vessel/annotate';
            
    case 's1.anotatr.com':
        if (typeLetter === 'cargo') {
            return 'https://mailparse.net/s1/cargo/annotate';
        } 
        return 'https://mailparse.net/s1/vessel/annotate';
            
    case '94.130.128.45': {
        if (typeLetter === 'cargo') {
            return 'http://94.130.128.45:8086/annotate';
        } 
        return 'http://94.130.128.45:8085/annotate';
    }
    case '1-shipdev.me': {
        if (typeLetter === 'cargo') {
            return 'https://mailparse.net/shipdev/cargo/annotate';
        } 
        return 'https://mailparse.net/shipdev/vessel/annotate';
    }
    case 'polza': {
        if (typeLetter === 'cargo') {
            return 'https://mailparse.net/polza/cargo/annotate';
        } 
        return 'https://mailparse.net/polza/vessel/annotate';
    }
    case 'mailparse.net':
    default:
    {
        return `https://mailparse.net/${typeLetter}/annotate`;
    }
    }
}

export function postAnnotations(
    text, 
    typeLetter, 
    typeServer, 
    options = {},
) {
    options = Object.assign(options, { timeout: 40 });
    const url = chooseServer(typeLetter, typeServer);

    const { isSimpleForm = undefined, subject = undefined, date = undefined } = options;

    return axios({
        method: 'POST',
        url,
        params: options,
        data: {
            isSimpleForm: isSimpleForm || undefined,
            text, 
            subject, 
            date,
        },
    })
        .then(response => response)
        .catch(response => response.response.data);
}

export function getFilters(user) {
    return axios({
        method: 'GET',
        url: '/get/',
        data: {
            id: user._id,
        },
    })
        .then(response => response)
        .catch(response => response.response.data);
}

export function getFilter(user, filter) {
    return axios({
        method: 'GET',
        url: '/get/',
        data: {
            id: user._id,
        },
    })
        .then(response => response)
        .catch(response => response.response.data);
}

export function updateFilter(id, filter) {
    return axios({
        method: 'POST',
        url: '/get/',
        data: {
            id: user._id,
        },
    })
        .then(response => response)
        .catch(response => response.response.data);
}

export function deleteFilter(id, filter) {
    return axios({
        method: 'POST',
        url: '/get/',
        data: {
            id: user._id,
        },
    })
        .then(response => response)
        .catch(response => response.response.data);
}

export function addFilter(id, filter) {
    return axios({
        method: 'POST',
        url: '/get/',
        data: {
            id: user._id,
        },
    })
        .then(response => response)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/annotations.js